import { useContext, useEffect } from 'react';
import portalTypeCheckers from '../../../../types/portalTypeCheckers';
import CurrentUserContext from '../../../../contexts/CurrentUserContext';
import { PortalsContext } from '../PortalsProvider';
import { UIVersion } from './types';

const useNavigateFleetOpsStaffToAdminPortal = (uiVersion: UIVersion) => {
  const { isFleetOpsStaff } = useContext(CurrentUserContext);
  const {
    isPortalsEnabled,
    selectedPortal,
    availablePortals,
    onPortalSelected,
  } = useContext(PortalsContext);
  /**
   * For FleetOps staff, select the admin portal by default
   * We need to sniff the pathname here as we have a dodgy flow where
   * this context provider has its state set via onPortalUrlSlugChanged
   * deeper in the render tree, from {@link PortalsSwitch}
   *
   * If this proves to be awkward to maintain going forward, the
   * selectedPortal state should be moved into its own context provider,
   * available after we know there is a :/portal/ in the url
   */
  useEffect(() => {
    if (!isFleetOpsStaff) {
      return;
    }

    if (uiVersion !== 'v2') {
      return;
    }

    if (selectedPortal) {
      return;
    }

    // We don't want to run this logic on a /:portal/ url
    if (window.location.pathname !== '/') {
      return;
    }

    const adminPortal = availablePortals.find(portalTypeCheckers.isAdminPortal);
    if (adminPortal) {
      onPortalSelected(adminPortal);
    }
  }, [
    availablePortals,
    isFleetOpsStaff,
    isPortalsEnabled,
    onPortalSelected,
    selectedPortal,
    uiVersion,
  ]);
};

export default useNavigateFleetOpsStaffToAdminPortal;
